import type { IconData } from '../../types';

export const data: IconData = {
  o: '<g fill-rule="evenodd" clip-rule="evenodd"><path d="M14 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M11 12V4h1v8zm4-8H1V3h14v1zm0 9H1v-1h14z"/></g>',
  f: '<g fill-rule="evenodd" clip-rule="evenodd"><path d="M14 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M11 12V4h1v8zm4-8H1V3h14v1zm0 9H1v-1h14z"/></g>',
  vb: '0 0 17 16',
};

export default data;
